import { gql } from 'graphql-request'

export const EXPORT_EBOOK_DASHBOARD = gql`
  query ExportEbookDashboard($startDate: DateTime!, $endDate: DateTime!) {
    exportEbookDashboard(startDate: $startDate, endDate: $endDate)
  }
`
